import axios, { AxiosInstance } from "axios";
import { cartOrderApiFactory } from "./cart";
export const client: AxiosInstance = axios.create({
  baseURL: "/",
  withCredentials: true,
});
export const cartOrderApi = cartOrderApiFactory(client);
